import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import FeedbackModal from '../feedback/FeedbackModal';
import '../../styles/components/Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [showFeedback, setShowFeedback] = useState(false);

  return (
    <footer className="site-footer">
      <div className="footer-content">
        <div className="footer-links">
          <button type="button" className="footer-link-button" onClick={() => setShowFeedback(true)}>Feedback</button>
          <span className="footer-link-separator">|</span>
          <Link to="/shop">Recommended Products</Link>
          <span className="footer-link-separator">|</span>
          <a href="https://buy.stripe.com/4gMdR85j5gftgsaaiB0RG01" target="_blank" rel="noopener noreferrer">Tip Jar</a>
          <span className="footer-link-separator">|</span>
          <Link to="/privacy-policy">Privacy Policy</Link>
          <span className="footer-link-separator">|</span>
          <Link to="/terms-of-service">Terms of Service</Link>
        </div>
        <div className="footer-attribution">
          Brought to you by <a href="https://TheCookiedBaker.com" target="_blank" rel="noopener noreferrer">The Cookied Baker</a>
        </div>
        <div className="footer-copyright">
          &copy; {currentYear} The Icing Calculator. All rights reserved.
        </div>
      </div>
      {showFeedback && <FeedbackModal onClose={() => setShowFeedback(false)} />}
    </footer>
  );
};

export default Footer;
